import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import FlatButton from 'material-ui/FlatButton';
import { changeSettings, changePassword } from '../actions/actions';

import countries from '../modules/countries';
import timezones from '../modules/timezones';

import apiErrors from '../modules/apierrors';
import getErrors from '../modules/geterrors';

// Taken from https://www.w3.org/TR/html5/forms.html#valid-e-mail-address
const emailRegexp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

class AccountMain extends Component {
  constructor(props) {
    super();

    this.state = {
      name: props.auth.user.name,
      email: props.auth.user.email,
      countryCode: props.auth.user.countryCode,
      timezone: props.auth.user.timezone,
      oldpassword: '',
      newpassword: '',
      newpasswordverify: '',
      dialogOpen: false,
      dialogType: null
    };
  }

  componentWillUpdate(nextProps) {
    if (this.props.auth.isFetchingPassword && !nextProps.auth.isFetchingPassword && nextProps.auth.errors.length === 0) {
      this.openDialog('password-change-success');
    }
  }

  openDialog = (type) => {
    this.setState({
        dialogOpen: true,
        type
    });
  }

  closeDialog = () => {
    this.setState({
        dialogOpen: false,
        type: null
    });
  }

  handleInput = () => {
    const data = {
      name: this.nameInput.getValue(),
      email: this.emailInput.getValue(),
    };
    this.setState({ ...data });
  }

  handleCountry = (event, index, value) => this.setState({ countryCode: value });

  handleTimezone = (event, index, value) => this.setState({ timezone: value });

  handleInfoChange(event) {
    event.preventDefault();
    const name = this.state.name.trim();
    const email = this.state.email.trim();
    const country_id = this.state.countryCode;
    const timezone = this.state.timezone;
    this.props.dispatch(changeSettings({ name, email, country_id, timezone }));
  }

  handlePasswordInput = () => {
    const data = {
      oldpassword: this.oldPasswordInput.getValue(),
      newpassword: this.newPasswordInput.getValue(),
      newpasswordverify: this.newPasswordConfirmationInput.getValue(),
    };
    this.setState({ ...data });
  }

  handlePasswordChange(event) {
    event.preventDefault();
    const oldpassword = this.state.oldpassword.trim();
    const newpassword = this.state.newpassword.trim();
    const newpasswordConfirmation = this.state.newpasswordverify.trim();
    const data = { oldpassword, newpassword, newpassword_confirmation: newpasswordConfirmation };
    this.props.dispatch(changePassword(data));
  }

  renderCountries = () => {
    return countries.map( (country, index) => <MenuItem key={index} value={country.country_code} primaryText={country.name} /> );
   }

   renderTimezones = () => {
     return timezones.map( (tz, index) => <MenuItem key={index} value={tz.name} primaryText={`${tz.name} (${tz.timezone})`} /> );
    }


  renderDialog = () => {

    if (!this.state.dialogOpen || this.state.type === null) {
      return <span key='emptydialog'></span>;
    }

    let title;
    let text;

    const okButton = <FlatButton
             label="OK"
             primary={true}
             keyboardFocused={true}
             onTouchTap={ () => this.closeDialog() }
           />;

         const  actions = [okButton];


    if (this.state.type === 'password-change-success') {
     title = 'Password changed!';
     text = 'Your password was changed successfully.';
    }

    return  (
      <Dialog
          title={title}
          actions={actions}
          modal={false}
          open={this.state.dialogOpen}
          onTouchTap={ () => this.setState({dialogOpen: false, type: ''})}
        >
          {text}
        </Dialog>
      );

  }


  renderAccountSettings() {
    const { validationErrors } = getErrors(this.props.auth.errors);
    const nameErrorMessage = apiErrors[validationErrors.name] || validationErrors.name;
    const emailErrorMessage = apiErrors[validationErrors.email] || validationErrors.email;

    const validSettings = this.state.name.length > 0 && this.state.email.match(emailRegexp);

    const disabled = !validSettings || this.props.isWaiting.CHANGE_SETTINGS;

    let groupName;

    if (this.props.auth.user && this.props.auth.user.group) {
      groupName = this.props.auth.user.group.name;
    }

    return (
      <Card className="card-wide">
        <CardHeader title="Account settings" />
        <CardText>
          {groupName && (<p>You belong to the group {groupName}.</p>)}
          <form>
            <TextField
              className="input-long"
              onChange={this.handleInput}
              errorText={nameErrorMessage}
              ref={(input) => { this.nameInput = input; }}
              type="text"
              name="name"
              value={this.state.name}
              floatingLabelText="Name"
            /><br />
            <TextField
              className="input-long"
              onChange={this.handleInput}
              ref={(input) => { this.emailInput = input; }}
              errorText={emailErrorMessage}
              type="text"
              name="email"
              value={this.state.email}
              floatingLabelText="Email"
            /><br / >
            <SelectField
              floatingLabelText="Country"
              value={this.state.countryCode}
              onChange={this.handleCountry}
              >
              {this.renderCountries()}
            </SelectField>
            <br />
              <SelectField
                floatingLabelText="Timezone"
                value={this.state.timezone || null}
                onChange={this.handleTimezone}
                >
                {this.renderTimezones()}
              </SelectField>
              <br /><br />
            <FlatButton disabled={disabled} onClick={event => this.handleInfoChange(event)} type="submit" label="Save changes" />
          </form>
        </CardText>
      </Card>
  );
  }

  renderPasswordSettings() {
    const { errorMessages, validationErrors } = getErrors(this.props.auth.errors);
    const oldPasswordErrorMessage = apiErrors[validationErrors.oldpassword] || validationErrors.oldpassword;
    const newPasswordErrorMessage = apiErrors[validationErrors.newpassword] || validationErrors.newpassword;

    const validSettings = this.state.oldpassword.length > 5 && this.state.newpassword.length > 5 && this.state.newpasswordverify.length > 5;

    const disabled = !validSettings || this.props.isWaiting.CHANGE_PASSWORD;

    const style = {
      margin: 'auto',
    };


    return (
      <Card style={style}>
        <CardHeader title="Change password" />
        <CardText>
          <form onChange={this.handlePasswordInput}>
            <TextField
              className="input-long"
              ref={(input) => { this.oldPasswordInput = input; }}
              errorText={oldPasswordErrorMessage}
              type="password"
              name="oldpassword"
              floatingLabelText="Current password"
            /><br />
            <TextField
              className="input-long"
              ref={(input) => { this.newPasswordInput = input; }}
              errorText={newPasswordErrorMessage}
              type="password"
              name="newpassword"
              floatingLabelText="New password"
            /><br />
            <TextField
              className="input-long"
              ref={(input) => { this.newPasswordConfirmationInput = input; }}
              type="password"
              name="newpasswordverify"
              floatingLabelText="Confirm new password"
            /><br />
            <FlatButton disabled={disabled} onClick={event => this.handlePasswordChange(event)} type="submit" label="Save password" />
          </form>
        </CardText>
        <CardText>{errorMessages.map((error, i) => <div key={i}><strong>{error}</strong></div>)}</CardText>
      </Card>
  );
  }

  render() {
    return (
      <div>
        {this.renderAccountSettings()}<br />
        {this.renderPasswordSettings()}
        {this.renderDialog()}
      </div>
    );
  }
}

export default AccountMain;



// WEBPACK FOOTER //
// ./src/components/AccountMain.js